<page-header titleText="Purchase Requests">
    <lsq-button
        *ngIf="
            (activeTabLabel$ | async) === routeQueryParams.PurchaseRequestsUploads ||
            (activeTabLabel$ | async) === undefined
        "
        class="upload-purchase-requests-button"
        (buttonClick)="openNewPurchaseRequestsModal()"
        i18n
    >
        Upload Files
    </lsq-button>
</page-header>

<div class="container-fluid page-container">
    <tabs [tabsConfig]="tabsConfig"></tabs>

    <ng-container
        *ngIf="
            (activeTabLabel$ | async) === routeQueryParams.PurchaseRequestsUploads ||
            (activeTabLabel$ | async) === undefined
        "
    >
        <div
            *ngIf="toastMessage"
            class="purchase-request-toast"
            [ngClass]="toastMessage == successMessage ? 'success' : 'error'"
        >
            <lsq-icon
                [type]="icons.ExclamationCircle"
                [color]="color.Black"
                height="20"
                width="20"
            ></lsq-icon>
            <div class="message">{{ toastMessage }}</div>
            <lsq-icon
                class="close-button"
                width="20"
                [type]="icons.CloseSmall"
                [color]="color.Black"
                (click)="toastMessage = null"
            >
            </lsq-icon>
        </div>

        <card>
            <div card-body>
                <lsq-data-table
                    [hasHeader]="true"
                    [isPaginated]="true"
                    [layoutFixed]="true"
                    [dataSource]="validationErrorsDataSource"
                    [noDataMessage]="noValidationErrorsI18n"
                >
                    <lsq-column
                        [column]="{
                            header: buyerNameI18n,
                            sortable: true,
                            key: 'buyerName',
                            truncateTextCss: true
                        }"
                    >
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: supplierNameI18n,
                            sortable: true,
                            key: 'supplierName',
                            truncateTextCss: true
                        }"
                    >
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: funderCompanyNamesI18n,
                            key: 'funderCompanyNames',
                            truncateTextCss: true
                        }"
                    >
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: invoiceIdI18n,
                            sortable: true,
                            key: 'invoiceId'
                        }"
                    >
                    </lsq-column>
                    <lsq-column
                        [alignRight]="true"
                        [column]="{
                            header: invoiceAmountI18n,
                            key: 'invoiceAmount'
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            {{ row.invoiceAmount | lsqCurrency }}
                        </ng-template>
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: errorMessageI18n,
                            key: 'message',
                            wrapText: true
                        }"
                    >
                    </lsq-column>
                </lsq-data-table>
            </div>
        </card>
    </ng-container>

    <ng-container
        *ngIf="(activeTabLabel$ | async) === routeQueryParams.PurchaseRequestsExistingRequests"
    >
        <card>
            <div right-header-content [formGroup]="purchaseRequestsFormGroup">
                <lsq-input
                    [placeholder]="searchPlaceholderI18n"
                    formControlName="purchaseRequestId"
                    [name]="'purchaseRequestId'"
                    [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                    [group]="purchaseRequestsFormGroup"
                >
                </lsq-input>
            </div>
            <div card-body>
                <lsq-data-table
                    [hasHeader]="true"
                    [isPaginated]="true"
                    [layoutFixed]="true"
                    [dataSource]="purchaseRequestsDataSource"
                >
                    <lsq-column
                        [column]="{
                            header: buyerNameI18n,
                            sortable: false,
                            key: 'buyerName',
                            truncateTextCss: true
                        }"
                    >
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: funderCompanyNamesI18n,
                            sortable: false,
                            key: 'funderCompanyNames',
                            truncateTextCss: true
                        }"
                    >
                    </lsq-column>
                    <lsq-column
                        [column]="{
                            header: purchaseIdI18n,
                            sortable: true,
                            key: 'id',
                            truncateTextCss: true
                        }"
                    >
                    </lsq-column>
                    <lsq-currency-column
                        [alignRight]="true"
                        [column]="{
                            header: totalFunderCapitalI18n,
                            sortable: false,
                            key: 'totalFunderCapital'
                        }"
                    >
                    </lsq-currency-column>
                    <lsq-column
                        [column]="{
                            header: markAsSoldI18n,
                            sortable: false,
                            key: 'sold',
                            width: '8%'
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            <lsq-switch
                                class="active-toggle"
                                [name]="'active'"
                                [ngModel]="row.sold"
                                (click)="openMarkPurchaseRequestModal($event, row)"
                            >
                            </lsq-switch>
                        </ng-template>
                    </lsq-column>
                    <lsq-date-column
                        [isShortDate]="true"
                        [column]="{
                            header: dateSoldI18n,
                            sortable: true,
                            key: 'soldDate'
                        }"
                    >
                    </lsq-date-column>
                </lsq-data-table>
            </div>
        </card>
    </ng-container>
</div>

<ng-template #createPurchaseRequestsModal>
    <new-purchase-requests-modal
        (onValidationErrors)="onValidationErrors($event)"
        (onSuccessfulUpload)="onSuccessfulUpload()"
    >
    </new-purchase-requests-modal>
</ng-template>
